/**
 * YesNoToggle — green/red pill pair used by the checklist (people) section.
 * Pure / controlled.
 */
export const YesNoToggle = ({ value, onChange }) => (
  <div className="flex gap-2">
    {['yes', 'no'].map((opt) => (
      <button
        key={opt}
        type="button"
        onClick={() => onChange(opt)}
        className={`px-4 py-1.5 rounded-full text-sm font-medium border transition-all ${value === opt ? opt === 'yes' ? 'bg-[#34C759] border-[#34C759] text-white' : 'bg-[#FF3B30] border-[#FF3B30] text-white' : 'border-[#E5E7EB] text-[#4B5563] hover:border-[#9CA3AF]'}`}
        data-testid={`toggle-${opt}`}
      >
        {opt === 'yes' ? 'Yes' : 'No'}
      </button>
    ))}
  </div>
);
